module.exports = "<div class=root> <site-header ng-if=$ctrl.showHeader()> </site-header> <ui-view></ui-view> <timeout-warning></timeout-warning> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/app.html
// module id = 334
// module chunks = 0